import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=a8ddfd8c&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8ddfd8c')) {
      api.createRecord('a8ddfd8c', component.options)
    } else {
      api.reload('a8ddfd8c', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=a8ddfd8c&", function () {
      api.rerender('a8ddfd8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/classPage/Footer.vue"
export default component.exports